<template>
  <div>
    <b-card header="Default">
      <div slot="header">
        {{ title }}
      </div>
      <div class="text-center" v-show="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <interviewLocationAudienceForm
        mode="edit"
        v-show="!isLoading"
        :visbale="true"
        :item="item"
        @submit="save"
        @closeModal="$emit('closeModal')"
      />
    </b-card>
  </div>
</template>
<script>
import interviewLocationAudienceForm from "./../forms/interviewLocationAudienceForm";
import { pathOr } from "ramda";

export default {
  name: "edit-interview-location-audience",
  components: {
    interviewLocationAudienceForm,
  },
  inject: ["interviewLocationPersonRepository"],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      id: this.$route.params.id,
    };
  },
  computed: {
    title() {
      const fullName = pathOr("", ["person_object", "full_name"], this.item);
      const nationalCode = pathOr(
        "",
        ["person_object", "national_code"],
        this.item
      );
      return `${this.$lang.editInterviewLocation} (${fullName} - ${nationalCode})`;
    },
  },
  methods: {
    pathOr,
    async save(getPayload) {
      try {
        this.isLoading = true;
        const payload = { ...getPayload, person_kind: 2 };
        const response =
          await this.interviewLocationPersonRepository.partial_edit(
            this.item.id,
            payload
          );
        this.$notify.success(response.data.message);
        this.$emit("refreshData");
        this.$emit("closeModal");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
